require('../modules/esnext.number.from-string');



//////////////////
// WEBPACK FOOTER
// /Volumes/Box/sites/wandsworthhub/app/bedrock/web/app/themes/wandsworthhub/node_modules/core-js/proposals/number-from-string.js
// module id = 497
// module chunks = 0